module.exports = __webpack_public_path__ + "static/media/20210411_070844430_iOS.8dac03d7.jpg";